module.exports = __webpack_public_path__ + "media/ccwl.e8216dd8.mp4";